<nb-card class="team-config-drawer">
  <nb-card-header>
    <div class="tc-kicker">{{ 'manage_team' | translate }}</div>
    <div class="tc-title-row">
      <h4>{{ deptName }}</h4>
      <button nbButton ghost size="tiny" (click)="close()" attr.aria-label="{{ 'close' | translate }}">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <section class="tc-field">
      <label for="tc-parent">{{ 'parent_department' | translate }}</label>
      <nb-select id="tc-parent" fullWidth [selected]="parentSelectValue" [disabled]="parentSaving"
                 (selectedChange)="onParentChange($event)">
        <nb-option [value]="NONE_PARENT">{{ 'none' | translate }}</nb-option>
        @for (d of departments; track d.id) {
          <nb-option [value]="d.id">{{ d.name }}</nb-option>
        }
      </nb-select>
    </section>

    <section class="tc-managers">
      <label>{{ 'managers' | translate }}</label>

      @if (managersLoading) {
        <div class="tc-hint">{{ 'loading' | translate }}</div>
      } @else if (managers.length === 0) {
        <div class="tc-hint">{{ 'no_managers' | translate }}</div>
      }

      @for (m of managers; track m.User_id) {
        <div class="tc-mgr-row">
          <span class="tc-mgr-name">{{ m.name }}</span>
          <button nbButton ghost status="danger" size="tiny" [disabled]="m.removing"
                  (click)="removeManager(m)" attr.aria-label="{{ ('remove' | translate) + ' ' + m.name }}">
            <nb-icon icon="close-outline"></nb-icon>
          </button>
        </div>
      }

      <fieldset class="tc-add" [disabled]="adding">
        <bst-user-picker [formControl]="picker" [disabled]="adding"></bst-user-picker>
      </fieldset>
    </section>
  </nb-card-body>
</nb-card>
